import { render, staticRenderFns } from "./PromoBlock.vue?vue&type=template&id=8b7b4582"
import script from "./PromoBlock.vue?vue&type=script&lang=js"
export * from "./PromoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports